export default __webpack_public_path__ + "static/media/k1.d3314535.png";